import { IBiz } from './biz'
import { Currency, IQueryParams, IPagination } from './common'

export enum ECategory {
  Qr = 'qr',
  Card = 'card',
}

export enum ECategoryUrl {
  qr = 'zebra',
  card = 'turtle',
  ec = 'eagle',
}

/* query è¯·æ±åæ° */
export interface ITradeQueryParams extends IQueryParams {
  chanCode?: string
  currency?: string
  endTime?: string
  procFlag?: string
  startTime?: string
  transScene?: string
  utcOffset?: number
}

/** äº¤æç»è®¡è¯·æ±åæ° */
export interface ITradeStatisticQueryParams extends IQueryParams {
  level?: string // æ±æ»çº¬åº¦
  currency?: string // å¸ç§ï¼å¿é¡»éå¸ç§
  paidAtFrom?: string
  paidAtTo?: string
  insCode?: string
  agentCode?: string
  intMerCode?: string
  intStoreCode?: string
  channel?: string
}

export interface ITradeStatistic {
  currency: string
  insCode: string
  insName: string
  agentCode: string
  agentName: string
  intMerCode: string
  merNum: string
  merName: string
  intStoreCode: string
  storeNum: string
  storeName: string
  totalTransAmt: number
  totalTransNum: number
  totalFee: number
  subtotalAmt: number
  tipsAmt: number
  negativeTransAmt: number
  negativeTransNum: number
  positiveTransAmt: number
  positiveTransNum: number
  alp?: ITradeStaticChanObj
  wxp?: ITradeStaticChanObj
  grb?: ITradeStaticChanObj
  tru?: ITradeStaticChanObj
  dot?: ITradeStaticChanObj
  vis?: ITradeStaticChanObj
  mcc?: ITradeStaticChanObj
  upi?: ITradeStaticChanObj
  data?: ITradeStatistic[]
}

export interface ITradeStaticChanObj {
  transAmt: number
  transNum: number
  refundAmt: number
  refundNum: number
  fee: number
  refundFee: number
}

/* æ¥è¯¢è¯¦æ è¯·æ±åæ° */
export interface ITradeDetailQueryParams {
  intStoreCode: string
  orderNum: string
}

/* äº¤æè¿åä¿¡æ¯ */
export interface ITrade extends IBiz {
  insCode: string // æºæå·
  insName: string // æºæåç§°
  agentCode: string // éå¢å·
  agentName: string // éå¢åç§°
  intMerCode: string // åé¨åæ·å·
  merNum: string // åæ·ç¼å·
  merName: string // åæ·åç§°
  intStoreCode: string // åé¨é¨åºå·
  storeNum: string // é¨åºç¼å·
  storeName: string // é¨åºåç§°
  terminalid: string // ç»ç«¯ç¼å·
  orderNum: string // è®¢åå·
  busicd: string // äº¤æç±»å
  chanCode: string // æ¸ éç¼å·
  chanMerId: string // æ¸ éåæ·å·
  currency: string // äº¤æå¸ç§
  chanTransAmt: number // æ¸ éäº¤æéé¢ï¼æ¸ éç«¯æ£æ¬¾å¸ç§ç¸åºçéé¢
  chanTransCurrency: string // æ¸ éäº¤æå¸ç§ï¼æ¸ éç«¯æ£æ¬¾å¸ç§
  category: ECategory
  paymentBrand: string // æ¸ éï¼æ¯ä»åç
  /** å¤æ­æ¯å¦æå */
  procFlag: string // å¤çæ å¿
  revFlag: ERevFlag // å²æ­£æ å¿
  refundAmt: number // éæ¬¾éé¢
  storeMcc: string // é¨åºMCC
  tradeFrom: string // äº¤ææ¥æºï¼androidï¼iosï¼webï¼docode etc.
  transAmt: number // äº¤æéé¢,
  transScene: string // äº¤æåºæ¯
  transTime: string // äº¤ææ¶é´
  transStatus: string // äº¤æç¶æ
  /** 1-æ¯ä» 2-éæ¬¾ 3-é¢ææ 4-æ¤é 5-å³å */
  transType: ETransType
  sysOrderNum: string // ç³»ç»è®¢åå·
  tradesRelated: ITrade[] // å³èäº¤æ
}

export enum ERevFlag {
  RevNormal = '0', // æ­£å¸¸
  RevRefunded = '3', // å·²éæ¬¾
  RevPartRefunded = 'P', // é¨åéæ¬¾
  RevClosed = 'C', // å·²å³é­
}

export enum ETransType {
  PayTrans = 1, // æ¯ä»äº¤æ
  RefundTrans = 2, // éæ¬¾äº¤æ
}

export enum EProcFlag {
  ProcHandling = '5', // äº¤æå¤çä¸­
  ProcFail = '2', // äº¤æå¤±è´¥
  ProcSuccess = '0', // äº¤ææå
}

export interface ITradePagination extends IPagination {
  data: ITrade[]
}

export interface ITradeStatisticPagination extends IPagination {
  data: ITradeStatistic
}

/* å¨çº¿æ¶æ¬¾ */
export interface ITradeOnlineCharge {
  onlinePayOrderNum: string
  no: string
  created: string
  storeName: string
  currency: string
  status: string
  commodity: string
  amount: string
  tradesRelated?: ITrade[]
}

/** å¨çº¿æ¶æ¬¾è¯·æ±åæ° */
export interface ITradeOnlineChargeQueryParams extends IQueryParams {
  insCode?: string // æºæç¼å·
  agentCode?: string // éå¢ç¼å·
  intMerCode?: string // åé¨åæ·ç¼å·
  intStoreCode?: string // åé¨é¨åºç¼å·
  onlinePayOrderNum?: string // å¨çº¿æ¶æ¬¾åå·
}

export interface ITradeOnlineChargePagination extends IPagination {
  data: ITradeOnlineCharge
}

export class OnlineChargeAddSystem {
  insCode: string // æºæå·
  insName: string // æºæåç§°
  insNameEN: string // æºæè±æåç§°

  agentCode: string // éå¢å·
  agentName: string // éå¢åç§°
  agentNameEN: string // éå¢è±æåç§°

  intMerCode: string // åæ·å·
  merName: string // åæ·åç§°
  merNameEN: string // åæ·è±æåç§°

  intStoreCode: string // åé¨é¨åºå·
  storeName: string // é¨åºåç§°
  storeNameEN: string // é¨åºè±æåç§°
}

export class OnlineChargeAddOrder {
  currency: Currency // å¸ç§ä¿¡æ¯
  amount: string // éé¢
  duration: string // è®¢åæææ
  commodity: string // åååç§°
  description: string // æ¶æ¬¾è¯´æ
}

export class OnlineChargeAddModel {
  systemInfo: OnlineChargeAddSystem
  orderInfo: OnlineChargeAddOrder
  constructor() {
    this.systemInfo = new OnlineChargeAddSystem()
    this.orderInfo = new OnlineChargeAddOrder()
  }
}

export enum EChargePaidStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  Close = 'Close',
}

export const ChargePaidStatusMap = {
  Paid: 'TRADE.CHARGE.STATUS.PAID',
  Unpaid: 'TRADE.CHARGE.STATUS.UNPAID',
  Close: 'TRADE.CHARGE.STATUS.CLOSE',
}

/** æ ¹æ®é¨åºç¼å·è¿åçé¨åºä¿¡æ¯ */

export interface StoreInfo extends IBiz {
  currencies: Currency[]
}

export interface ITradeRefund {
  /**
   * ææç 
   */
  authPassword?: string

  /**
   * åé¨é¨åºå·
   */
  intStoreCode: string

  /**
   * åäº¤æè®¢åå·
   */
  origOrderNum: string

  /**
   * éæ¬¾éé¢
   */
  txamt: string

  /**
   * å¸ç§
   */
  currency: string

  /**
   * å¹³å°ç¨æ·å
   */
  username: string

  /**
   * éæ¬¾è¯´æ
   */
  refundDetail: string
}

export enum ERefundType {
  MerchantRefund = 'merchantRefund',
  ManualRefund = 'manualRefund',
}
